import React, { useState, useRef, useEffect } from 'react';
import styles from './CustomerPhotos.module.css';

const images = Array.from({ length: 10 }, (_, i) => `client-${i + 1}.jpeg`);

function CustomerPhotos() {
  const [index, setIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(5);
  const trackRef = useRef(null);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setVisibleCount(mq.matches ? 2 : 5);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  const maxIndex = Math.max(0, images.length - visibleCount);

  const handleScroll = () => {
    if (!trackRef.current || maxIndex === 0) return;
    const { scrollLeft, scrollWidth, clientWidth } = trackRef.current;
    const maxScroll = scrollWidth - clientWidth;
    const step = maxScroll / maxIndex;
    const newIndex = Math.round(scrollLeft / step);
    setIndex(Math.min(Math.max(0, newIndex), maxIndex));
  };

  const goTo = (i) => {
    if (!trackRef.current || maxIndex === 0) return;
    const { scrollWidth, clientWidth } = trackRef.current;
    const maxScroll = scrollWidth - clientWidth;
    const step = maxScroll / maxIndex;
    trackRef.current.scrollTo({ left: i * step, behavior: 'smooth' });
  };

  const baseUrl = process.env.PUBLIC_URL || '';

  return (
    <section className={styles.section}>
      <div
        ref={trackRef}
        className={styles.track}
        onScroll={handleScroll}
      >
        {images.map((src, i) => (
          <div key={i} className={styles.slide}>
            <img src={`${baseUrl}/${src}`} alt="Happy customer with Bird Motorbike scooter rental in Phuket" loading="lazy" />
          </div>
        ))}
      </div>
      <div className={styles.dots}>
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <button
            key={i}
            type="button"
            className={`${styles.dot} ${i === index ? styles.dotActive : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default CustomerPhotos;
